import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { NegocioOportunidadeSearch } from '../negocio-oportunidade-search';

@Injectable({
    providedIn: 'root'
})
export class NegocioOportunidadeDuplicateHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/crm/negociooportunidade`;
    }

    /** Duplica a oportunidade de negócio */
    duplicate(id: number): Observable<NegocioOportunidadeSearch> {
        return this.customHttp.get<NegocioOportunidadeSearch>(`${this.pathApi}/${id}/duplicate`);
    }
}
